import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';

interface InputFieldProps {
  label?: string; // optional
  placeholder: string;
  register: UseFormRegisterReturn;
  error?: FieldError;
  type?: string;
  defaultValue?:string|number,
  step?:string
  readOnly?:boolean
}

const InputField: React.FC<InputFieldProps> = ({ label, placeholder, register, error, defaultValue,type = "text" ,step,readOnly=false}) => {
  return (
    <div className="mb-4">
      {label && (
        <label className="block text-sm font-semibold text-Black mb-2 capitalize">
          {label}
        </label>
      )}
      <input
        autoComplete="off"
        type={type}
        min={1}
        placeholder={placeholder}
        defaultValue={defaultValue}
        step={step}
        readOnly={readOnly}
        {...register}
        className={`w-full p-3 rounded-[8px] border ${
          error ? 'border-danger' : ' border-LightGrey3'
        } focus:outline-none focus:ring-2 focus:ring-primary placeholder:text-sm`} 
        // placeholder size fixed to small
      />
      {error && <span className="text-danger text-sm mt-1 block">{error.message}</span>}
    </div>
  );
};

export default InputField;
